const MAPBOX_KEY = 'pk.eyJ1IjoidndwLWdlbmVyaWMiLCJhIjoiY2xmOXZpNWlvMjJubTQwb2M0MW5vZzhoMyJ9.N-qswdKq0_wboOrqKaepMw';
const API_URL = 'https://api.guidos.fun';

const TRANSLATE_URL='https://libraries.guidos.fun/highlight/'

export {
    MAPBOX_KEY,
    API_URL,
    TRANSLATE_URL
}